import { useState } from 'react';

import type { ApiUserUsername } from '#/api/types/ApiTypedId';
import { Button } from '#/components/Button/Button';
import type { ButtonVariant } from '#/components/Button/Button.types';
import { useI18n } from '#/i18n/hooks/useI18n';
import { showModal } from '#/zustand-stores/modalStore';

type Props = {
  username: ApiUserUsername;
  onClick: () => void;
};

export function UnfollowButton(props: Props) {
  const { i18n } = useI18n();

  const { username, onClick } = props;

  const [variant, setVariant] = useState<ButtonVariant>('secondary');
  const [text, setText] = useState(i18n('Following'));

  return (
    <Button
      type="button"
      onClick={(e) => {
        e.preventDefault();

        showModal('UNFOLLOW', {
          username,
          handleSubmit: onClick,
        });
      }}
      variant={variant}
      qaId="unfollow"
      onMouseOver={() => {
        setVariant('danger');
        setText(i18n('Unfollow'));
      }}
      onMouseOut={() => {
        setVariant('secondary');
        setText(i18n('Following'));
      }}
    >
      {text}
    </Button>
  );
}
